import { gql } from "@apollo/client";

export const KPI_METRICS_QUERY = gql`
  query GetKpiMetrics {
    kpi {
      totalOrders
      newOrders
      completeOrders
      readyToReturnOrders
      totalProducts
      lowStockProducts
      closedOrDisapprovedProducts
      orderStats {
        lastSevenDaysTotal
        percentageChange
        completedPercentage
        pendingPercentage
        dailyCounts {
          date
          count
          amount
        }
      }
    }
  }
`;
